/*
 * RÉCAP KICKFLIP — lignes du panier lisibles (v1)
 * ---------------------------------------------------------------------------
 * Kickflip envoie UNE ligne Shopify de quantité 1 au prix total (ex. 14
 * maillots = « × 1 — 350 € »), avec une quarantaine de propriétés (#1…#14,
 * options du design, « Untitled answer ») et, une fois les variantes reliées,
 * des composants à 0 € (« × 4 », « × 1 »…) sans nom de taille.
 *
 * Ce script réécrit l'AFFICHAGE de ces lignes dans le panier (page et tiroir) :
 *   « 14 pièces · 25,00 € la pièce », tailles résumées (« M × 5 · L × 4 »),
 *   détail des pièces et de la personnalisation dépliables.
 * Il ne modifie ni le panier ni les prix : seulement ce qui est affiché.
 *
 * Chargé sur toutes les pages (section « RÉCAP KICKFLIP » du groupe d'en-tête),
 * car le tiroir panier s'ouvre partout. Les lignes sont retrouvées par leur
 * clé (data-key de snippets/cart-products.liquid, clé de /cart.js).
 */
(function () {
  'use strict';
  if (window.RecapKickflip) return;

  var isEditor = false;
  try { isEditor = !!(window.Shopify && window.Shopify.designMode); } catch (e) {}

  var nativeFetch = window.fetch.bind(window);
  var ORDRE_TAILLES = ['2 ans', '4 ans', '6 ans', '8 ans', '10 ans', '12 ans', '14 ans', '16 ans',
    'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', '3XL', 'XXXL', '4XL', '5XL', '6XL', '7XL', '8XL'];

  /* ---------------------------------------------------------------- outils */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  /* Même format que les prix du thème : « €1.050,00 ». */
  function euros(cents) {
    var p = (Math.round(cents) / 100).toFixed(2).split('.');
    return '€' + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + p[1];
  }
  function estQuantite(k) {
    k = String(k || '').trim().toLowerCase();
    return k === 'quantité' || k === 'quantite' || k === 'quantity';
  }
  /* Quantité Kickflip de la ligne (propriété « Quantité », par unité native), 0 si absente. */
  function quantiteKickflip(item) {
    var natif = item.quantity || 1;
    var props = item.properties || {};
    if (props._mczr_attributes) {
      try {
        var attrs = JSON.parse(props._mczr_attributes);
        for (var a = 0; Array.isArray(attrs) && a < attrs.length; a++) {
          if (estQuantite(attrs[a] && attrs[a].key)) {
            var q = parseInt(attrs[a].value, 10);
            if (q > 0) return q * natif;
          }
        }
      } catch (e) {}
    }
    for (var k in props) {
      if (estQuantite(k)) {
        var p = parseInt(props[k], 10);
        if (p > 0) return p * natif;
      }
    }
    return 0;
  }
  /* « Nom dans le dos (laisser vide si aucun nom) » → « Nom dans le dos ». */
  function libelle(l) { return String(l).replace(/\s*\([^)]*\)\s*/g, ' ').replace(/\s+/g, ' ').trim(); }
  function estLien(v) { return /^https?:\/\//i.test(String(v).trim()); }
  function vide(v) { v = String(v == null ? '' : v).trim(); return !v || /^untitled answer$/i.test(v); }

  /* Une pièce : « Nom dans le dos (…): DUPONT / Numéro (…): 9 / Taille: M / Quantité: 1 ». */
  function lirePiece(valeur) {
    var piece = { taille: '', quantite: 1, infos: [] };
    String(valeur).split(' / ').forEach(function (morceau) {
      var i = morceau.indexOf(':');
      if (i === -1) { if (!vide(morceau)) piece.infos.push(morceau.trim()); return; }
      var cle = libelle(morceau.slice(0, i)), val = morceau.slice(i + 1).trim();
      if (/taille/i.test(cle)) piece.taille = val;
      else if (estQuantite(cle)) { var q = parseInt(val, 10); if (q > 0) piece.quantite = q; }
      else if (!vide(val)) piece.infos.push(val);
    });
    return piece;
  }
  function rangTaille(t) {
    var i = ORDRE_TAILLES.indexOf(String(t).toUpperCase().replace(/\s+ANS$/, ' ans'));
    return i === -1 ? 999 : i;
  }

  /* Tout ce qu'on affiche pour une ligne Kickflip. */
  function analyserLigne(item, total) {
    var props = item.properties || {};
    var pieces = [], options = [];
    Object.keys(props).forEach(function (k) {
      var v = props[k];
      if (k.charAt(0) === '_' || estQuantite(k) || vide(v)) return;
      if (/^#\d+$/.test(k.trim())) { pieces.push({ n: parseInt(k.trim().slice(1), 10), p: lirePiece(v) }); return; }
      options.push({ cle: libelle(k), val: v });
    });
    pieces.sort(function (a, b) { return a.n - b.n; });
    var parTaille = {}, ordre = [];
    pieces.forEach(function (x) {
      var t = x.p.taille || '?';
      if (!(t in parTaille)) { parTaille[t] = 0; ordre.push(t); }
      parTaille[t] += x.p.quantite;
    });
    ordre.sort(function (a, b) { return rangTaille(a) - rangTaille(b); });
    return {
      total: total,
      /* prix APRÈS les réductions de la ligne (Pack Match…), comme le total affiché par le thème (Izidine, 30/10) */
      unite: total > 0 ? (item.final_line_price != null ? item.final_line_price : item.original_line_price) / total : 0,
      tailles: ordre.filter(function (t) { return t !== '?'; }).map(function (t) { return t + ' × ' + parTaille[t]; }),
      pieces: pieces,
      options: options
    };
  }

  /* ------------------------------------------------------------ affichage */
  var CSS = [
    '.rk-bloc{margin-top:8px;display:flex;flex-direction:column;gap:6px;font-size:13.5px;line-height:1.4}',
    '.rk-qte{display:inline-flex;align-self:flex-start;align-items:center;gap:6px;padding:4px 10px;border-radius:999px;background:#FFF1E6;color:#B84F08;font-weight:700;font-size:13px}',
    '.rk-tailles{color:inherit}',
    '.rk-tailles b{font-weight:600}',
    '.rk-bloc details{border-top:1px solid rgba(0,0,0,.08);padding-top:6px}',
    '.rk-bloc summary{cursor:pointer;color:#B84F08;font-weight:600;list-style:revert}',
    '.rk-bloc ol,.rk-bloc ul{margin:6px 0 0;padding-left:20px}',
    '.rk-bloc li{margin:2px 0}',
    '.rk-muted{opacity:.7}',
    '.rk-pieces-qte{font-weight:600;white-space:nowrap}',
    '[data-rk] .cart-items__properties,[data-rk] .cart-items__bundle{display:none!important}'
  ].join('\n');
  function injecterCss() {
    if (document.getElementById('rk-styles')) return;
    var st = document.createElement('style');
    st.id = 'rk-styles';
    st.textContent = CSS;
    (document.head || document.documentElement).appendChild(st);
  }

  function blocHTML(a) {
    var h = '<span class="rk-qte">' + a.total + ' pièce' + (a.total > 1 ? 's' : '') + ' · ' + esc(euros(a.unite)) + ' la pièce</span>';
    if (a.tailles.length) h += '<span class="rk-tailles"><b>Tailles :</b> ' + esc(a.tailles.join(' · ')) + '</span>';
    if (a.pieces.length) {
      h += '<details><summary>Voir les ' + a.pieces.length + ' pièce' + (a.pieces.length > 1 ? 's' : '') + '</summary><ol>' +
        a.pieces.map(function (x) {
          var morceaux = x.p.infos.slice();
          if (x.p.taille) morceaux.push(x.p.taille);
          return '<li>' + (morceaux.length ? esc(morceaux.join(' · ')) : '<span class="rk-muted">sans nom</span>') +
            (x.p.quantite > 1 ? ' <span class="rk-pieces-qte">× ' + x.p.quantite + '</span>' : '') + '</li>';
        }).join('') + '</ol></details>';
    }
    if (a.options.length) {
      h += '<details><summary>Voir la personnalisation</summary><ul>' +
        a.options.map(function (o) {
          var val = estLien(o.val) ? '<a href="' + esc(o.val) + '" target="_blank" rel="noopener">voir l\'image</a>' : esc(o.val);
          return '<li>' + esc(o.cle) + ' : ' + val + '</li>';
        }).join('') + '</ul></details>';
    }
    return h;
  }

  function reecrireLigne(ligne, item) {
    var total = quantiteKickflip(item);
    if (!total) return;   /* ligne ordinaire : affichage du thème inchangé */
    var a = analyserLigne(item, total);
    ligne.setAttribute('data-rk', '1');
    var ancien = ligne.querySelector('.rk-bloc');
    if (ancien) ancien.remove();
    var bloc = document.createElement('div');
    bloc.className = 'rk-bloc';
    bloc.innerHTML = blocHTML(a);
    var place = ligne.querySelector('.cart-items__variants-wrapper') || ligne.querySelector('.cart-items__details');
    if (place) place.appendChild(bloc);
    /* prix unitaire affiché par le thème = prix de la ligne entière : on le remplace */
    var unit = ligne.querySelector('.cart-items__unit-price-wrapper');
    if (unit) unit.innerHTML = '<span>' + esc(euros(a.unite)) + ' la pièce</span>';
  }

  /* --------------------------------------------------------------- moteur */
  var enCours = false, relancer = false;
  function appliquer() {
    if (isEditor) return;
    /* data-rk-vu = clé déjà traitée (toutes les lignes, Kickflip ou non) : une
       ligne n'est relue qu'après avoir été redessinée par le thème. */
    var lignes = document.querySelectorAll('.cart-items__table-row[data-key]');
    var aFaire = [];
    for (var i = 0; i < lignes.length; i++) {
      if (lignes[i].getAttribute('data-rk-vu') !== lignes[i].getAttribute('data-key')) aFaire.push(lignes[i]);
    }
    if (!aFaire.length) return;
    if (enCours) { relancer = true; return; }
    enCours = true;
    injecterCss();
    nativeFetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var parCle = {};
        (cart.items || []).forEach(function (it) { parCle[it.key] = it; });
        aFaire.forEach(function (ligne) {
          var cle = ligne.getAttribute('data-key');
          ligne.setAttribute('data-rk-vu', cle);
          if (parCle[cle]) reecrireLigne(ligne, parCle[cle]);
        });
      })
      .catch(function () {})
      .then(function () {
        enCours = false;
        if (relancer) { relancer = false; setTimeout(appliquer, 50); }
      });
  }

  var minuterie = null;
  function planifier() { clearTimeout(minuterie); minuterie = setTimeout(appliquer, 120); }

  function demarrer() {
    appliquer();
    /* le panier (page et tiroir) est redessiné par le thème à chaque modification */
    try {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) { planifier(); return; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
    ['cart:update', 'cart:updated', 'cart:refresh'].forEach(function (ev) { document.addEventListener(ev, planifier); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();

  window.RecapKickflip = {
    v: 1,
    appliquer: appliquer,
    /* exposés pour les tests */
    _analyserLigne: analyserLigne,
    _quantiteKickflip: quantiteKickflip,
    _blocHTML: blocHTML
  };
})();
